<template>
	<el-breadcrumb separator-class="el-icon-arrow-right">
		<el-breadcrumb-item :to="{ path: item.path }" v-for="(item,index) in breadcrumbList" :key="index">{{item.title}}</el-breadcrumb-item>
	</el-breadcrumb>
</template>

<script>
export default {
	data() {
		return {
			breadcrumbList: []
		};
	},
	created() {
		// console.log(this.$route);
		this.getBreadcrumbList()
	},
	methods: {
		getBreadcrumbList(){
			let projectData=sessionStorage.getItem("projectData")
			let breadcrumbList = this.$route.matched.map(item=>{
				let data={path:item.path,title:item.meta.title}
				if(projectData && item.meta.isProjectName){
					data.title=JSON.parse(projectData).projectName
				}
				return data
			})
			this.breadcrumbList = breadcrumbList
		}
	}
};
</script>

<style scoped lang="scss">
</style>
